<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- FORM -->

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="brandyType"
        [label]="TITLE + 'BRANDY_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BRANDY_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="brandyTypes | toSelectOption: 'PRODUCTS.BRANDY_TYPE.'"
        (ngModelChange)="onCognacTypeSelected($event)"
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field *ngIf="getCtrl('brandyOrWinebrandType')">
      <app-easy-select
        formControlName="brandyOrWinebrandType"
        [label]="TITLE + 'BRANDY_OR_WINEBRAND' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BRANDY_OR_WINEBRAND_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          brandyOrWinebrandTypes
            | toSelectOption: 'PRODUCTS.BRANDY_OR_WINEBRAND_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        formControlName="agingCategory"
        [label]="TITLE + 'AGING_CATEGORY' | translate"
        [translatePrefixForSelected]="'PRODUCTS.AGING_CATEGORY.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="agingCategories | toSelectOption: 'PRODUCTS.AGING_CATEGORY.'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <!-- agingTime number & unit select -->

    <mat-form-field>
      <app-easy-input
        formControlName="agingTime"
        [label]="TITLE + 'AGING_TIME' | translate"
        type="number"
        min="1"
        (ngModelChange)="
          $event
            ? getCtrl('agingTimeUnit')?.setValidators(Validators.required)
            : getCtrl('agingTimeUnit')?.clearValidators()
        "
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        formControlName="agingTimeUnit"
        [label]="TITLE + 'AGING_TIME_UNIT' | translate"
        [translatePrefixForSelected]="'PRODUCTS.AGING_TIME_UNIT.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="agingTimeUnits | toSelectOption: 'PRODUCTS.AGING_TIME_UNIT.'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <mat-form-field *ngIf="getCtrl('barrelType')">
    <app-easy-select
      formControlName="barrelType"
      [label]="TITLE + 'BARREL_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.BARREL_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [options]="barrelTypes | toSelectOption: 'PRODUCTS.BARREL_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
